import type { U2000CriteriaStaticOption } from '../../u2000Core/components/tables/basic/U2000BasicTableList';
import {
  u3155ResolveFamilyLabel,
  type U3155FamilyItem,
} from '../U3155Service';

function compareFamilyLabels(a: U3155FamilyItem, b: U3155FamilyItem, language: string): number {
  const lang = language || 'fr';
  const labelA = u3155ResolveFamilyLabel(a, lang);
  const labelB = u3155ResolveFamilyLabel(b, lang);
  const cmp = labelA.localeCompare(labelB, lang, { sensitivity: 'base' });
  if (cmp !== 0) return cmp;
  const codeA = a.familyCode?.trim() ?? '';
  const codeB = b.familyCode?.trim() ?? '';
  return codeA.localeCompare(codeB, lang, { sensitivity: 'base' });
}

/** Familles initLU triées (sortOrder puis libellé). BL-0694 */
export function sortU3155FamiliesByLabel(families: U3155FamilyItem[], language: string): U3155FamilyItem[] {
  if (!families.length) return [];
  const lang = language || 'fr';
  return [...families].sort((a, b) => {
    const orderA = a.sortOrder ?? 0;
    const orderB = b.sortOrder ?? 0;
    if (orderA !== orderB) return orderA - orderB;
    return compareFamilyLabels(a, b, lang);
  });
}

export function u3155FormatFamilyOptionLabel(family: U3155FamilyItem, language: string): string {
  const label = u3155ResolveFamilyLabel(family, language);
  const code = family.familyCode?.trim();
  return code && label ? `${label} (${code})` : label || code || '';
}

/** Options critère recherche `family.id` (U3155). */
export function buildU3155FamilyCriteriaOptions(
  language: string,
  families?: U3155FamilyItem[],
): U2000CriteriaStaticOption[] {
  if (!families?.length) return [];
  const lang = language || 'fr';
  return sortU3155FamiliesByLabel(families, lang).map((item) => ({
    value: item.id,
    label: u3155FormatFamilyOptionLabel(item, lang),
  }));
}
